import { dateHelpers } from "@runn/calculations"

import { getDaysInRange } from "./CalendarHelper"
import { calculateStartAndEndDatesWithinRange } from "./daysObjectHelpers"

export type Phase = {
  id: number
  name: string
  color: string
  start_date?: string
  end_date?: string
  revenue_budget?: number
  phase_roles?: ReadonlyArray<{
    id: number
    role_id: number
    phase_id: number | null
    estimated_minutes: number
  }>
}

export const getGridAttributes = ({
  start,
  end,
  calendarStartDate,
  calendarEndDate,
  dayWidth,
  calendarWeekendsExpanded,
}: {
  start: Date
  end: Date
  calendarStartDate: Date
  calendarEndDate: Date
  dayWidth: number
  calendarWeekendsExpanded: boolean
}) => {
  // only get dates within the calendarRange
  const datesWithinRange =
    start &&
    calculateStartAndEndDatesWithinRange(
      {
        start_date: dateHelpers.formatToRunnDate(start),
        end_date: dateHelpers.formatToRunnDate(end || start),
      },
      calendarStartDate,
      calendarEndDate,
    )

  const gridStart = start
    ? getDaysInRange({
        start: calendarStartDate,
        end: datesWithinRange.startDate,
        includeWeekends: calendarWeekendsExpanded,
      })
    : null

  const gridSpan =
    (end &&
      getDaysInRange({
        start: datesWithinRange.startDate,
        end: datesWithinRange.endDate,
        includeWeekends: calendarWeekendsExpanded,
      })) ||
    1
  const lengthInPx = Math.abs(gridSpan * dayWidth)

  return {
    gridStart,
    gridSpan,
    lengthInPx,
  }
}
